'use client';

import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { SimpleBlock } from '../SimpleBlock';
import { StoreBlockContext } from './StoreBlockContext';
import { DefaultsProvider } from '../../util';
const StyledActionGroup = styled(SimpleBlock.ActionGroup).withConfig({
  componentId: "aui__sc-pvtp4d-0"
})(["margin-top:var(--aui-spacing-200);"]);
export const ActionGroup = ({
  children,
  ...props
}) => {
  const {
    size
  } = useContext(StoreBlockContext);
  const actionSize = {
    sm: 'sm',
    lg: 'md',
    xl: 'md'
  }[size];
  return /*#__PURE__*/React.createElement(StyledActionGroup, props, /*#__PURE__*/React.createElement(DefaultsProvider, {
    value: {
      actionSize
    }
  }, children));
};